import * as Sentry from "@sentry/react";

import { ErrorFallback } from "./error-fallback";

interface RouterErrorComponentProps {
  error: Error;
  reset?: () => void;
}

export const RouterErrorComponent = ({ error, reset }: RouterErrorComponentProps) => {
  Sentry.withScope((scope) => {
    scope.setTag("errorBoundary", "RouterErrorComponent");
    scope.setContext("errorInfo", {
      message: error.message,
      stack: error.stack,
    });
    Sentry.captureException(error);
  });

  return <ErrorFallback error={error} resetError={reset} source="router" />;
};
